import { defineRule } from "vee-validate";
import * as yup from "yup";
import i18n from "@/plugin/i18n";

const { t } = i18n.global;

export default function () {
  //YUP validation style
  //https://www.npmjs.com/package/yup

  defineRule("required", (value: any) => {
    if (!value || !value.length) {
      return "This field is required";
    }

    return true;
  });

  defineRule("requiredNumber", (value: any) => {
    if (!value || value === 0) {
      return "This field is required";
    }

    return true;
  });

  defineRule("requiredTrue", (value: any) => {
    if (value == "false" || !value || !value.length) {
      return "This field is required";
    }

    return true;
  });

  defineRule("required_yup", async (value: any): Promise<any> => {
    try {
      let valid = await yup.string().email().required().validate(value);

      return true;
    } catch (error: any) {
      return error.message;
    }
    return true;
  });

  defineRule("minMax", (value: string | any[], [min, max]: any) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }
    const numericValue = Number(value);
    if (numericValue < min) {
      return `This field must be greater than ${min}`;
    }
    if (numericValue > max) {
      return `This field must be less than ${max}`;
    }
    return true;
  });

  defineRule("minLength", (value: string | any[], [limit]: any) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }
    if (value.length < limit) {
      return `This field must be at least ${limit} characters`;
    }
    return true;
  });

  defineRule("fixedLength", (value: string | any[], [limit]: any) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
      return true;
    }
    if (value.length != limit) {
      return `This field must be ${limit} characters`;
    }
    return true;
  });

  defineRule("minLengthNumber", (value: Number | any[], [limit]: any) => {
    // The field is empty so it should pass
    if (value === null || value === undefined) {
      return true;
    }
    const stringValue = String(value);
    if (!stringValue.length) {
      return true;
    }
    if (stringValue.length < limit) {
      return `Minimum ${limit} characters`;
    }
    return true;
  });

  defineRule("maxLengthNumber", (value: Number | any[], [limit]: any) => {
    if (value === null || value === undefined) {
      return true;
    }
    const stringValue = String(value);
    if (!stringValue.length) {
      return true;
    }
    if (stringValue.length > limit) {
      return `Maxiumum ${limit} characters`;
    }
    return true;
  });

  //Customize error Msg
  defineRule("email", (value: any) => {
    // Field is empty, should pass
    if (!value || !value.length) {
      return true;
    }
    // const emailRegex =
    //   /^[a-zA-Z0-9]+([._]?[a-zA-Z0-9!#$%&'*+\-/=?^`{|}~]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(value)) {
      return "This field must be a valid email. e.g.xxx@gmail.com";
    }
    return true;
  });

  defineRule("referenceNo", (value: any) => {
    // Field is empty, should pass
    if (!value || !value.length) {
      return true;
    }

    // Define the regex pattern for reference number
    const referenceNoRegex = /^CC\d{20}$/;

    // Check if it matches the pattern
    if (!referenceNoRegex.test(value)) {
      return "Invalid format";
    }

    return true;
  });

  defineRule("creditCardFormat", (value: any) => {
    if (!value || value.length < 19) {
      return "Please Enter Valid Format";
    }

    return true;
  });

  defineRule("invalidPostCode", (value: any) => {
    return "Invalid Postcode";
  });

  defineRule("invalidNationality", (value: any) => {
    return "Nationality cannot be Malaysia";
  });
}

// defineRule("icNo", (value: any) => {
//   if (!value || value.length !== 12) {
//     return "Invalid Format";
//   }

//   const thirdAndFourthDigits = parseInt(value.substr(2, 2), 10);
//   const fifthAndSixthDigits = parseInt(value.substr(4, 2), 10);

//   if (thirdAndFourthDigits < 1 || thirdAndFourthDigits > 12) {
//     return "Invalid Format";
//   }

//   if (fifthAndSixthDigits < 1 || fifthAndSixthDigits > 31) {
//     return "Invalid Format";
//   }

//   return true;
// });

defineRule("icNo", (value: any) => {
  if (!value || typeof value !== "string" || !/^\d{12}$/.test(value)) {
    return "Invalid Format";
  }

  const yy = parseInt(value.substr(0, 2), 10);
  const mm = parseInt(value.substr(2, 2), 10);
  const dd = parseInt(value.substr(4, 2), 10);

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentYY = currentYear % 100;

  let fullYear: number;

  if (yy <= currentYY) {
    fullYear = 2000 + yy; // e.g., 25 → 2025
  } else {
    fullYear = 1900 + yy; // e.g., 99 → 1999
  }

  const dateStr = `${fullYear}-${String(mm).padStart(2, "0")}-${String(
    dd
  ).padStart(2, "0")}`;
  const date = new Date(dateStr);

  if (
    isNaN(date.getTime()) ||
    date.getFullYear() !== fullYear ||
    date.getMonth() + 1 !== mm ||
    date.getDate() !== dd
  ) {
    return "Invalid Format";
  }

  return true;
});

defineRule("maxValue", (value: Number | any[], [limit, placeholder]: any[]) => {
  if (value === null || value === undefined) {
    return true;
  }
  const stringValue = String(value);
  if (!stringValue.length) {
    return true;
  }
  const numericValue = Number(stringValue);
  if (numericValue > limit) {
    return `Not more than ${placeholder}`;
  }
  return true;
});

defineRule("maxValue_LoE", (value: any | any[], [limit]: any) => {
  // The field is empty so it should pass
  const stringValue = parseInt(value);

  if (stringValue > limit) {
    return "Please input correct length of Employment";
  }
  return true;
});

defineRule("numberFormat", (value: any) => {
  if (
    value === null ||
    value === undefined ||
    isNaN(value) ||
    /\s/.test(value)
  ) {
    return "Invalid Format";
  }

  return true;
});

defineRule("sameMobile", (value: any, mobile: any) => {
  if (mobile[0] == mobile[1]) {
    return "Mobile No must differ from principal card";
  }
  return true;
});

defineRule("alphabetAndSpaceFormat", (value: any) => {
  if (value === null || value === undefined || typeof value !== "string") {
    return "Invalid Format";
  }

  const regex = /^[a-zA-Z\s\t]*$/;
  if (!regex.test(value)) {
    return "Only alphabetic characters are allowed.";
  }

  return true;
});

defineRule("customFormat", (value: any) => {
  const allowedCharactersRegex = /^[a-zA-Z0-9&.\-()'\s_]+$/;

  if (!allowedCharactersRegex.test(value)) {
    return "Invalid Format";
  }

  return true;
});

defineRule("nameFormat", (value: any) => {
  const allowedCharactersRegex = /^[a-zA-Z]+[a-zA-Z@#()_:\/.,'\-\s]*$/;

  if (!allowedCharactersRegex.test(value)) {
    return "Invalid Format";
  }

  return true;
});

defineRule("nameFormat2", (value: any) => {
  const firstChar = value.charAt(0);
  if (!/[a-zA-Z]/.test(firstChar)) {
    return "Invalid Format";
  }
  return true;
});

defineRule("maxAge", (value: string, maxAge: string) => {
  if (typeof value !== "undefined" && value !== null) {
    const last4DigitsAsNumber = parseInt(value.substring(value.length - 4), 10);
    const monthAsNumber = parseInt(value.substring(3, 5));
    const day = parseInt(value.substring(0, 2));
    const currentYearLastTwoDigits = parseInt(
      new Date().getFullYear().toString(),
      10
    );
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = new Date().getDate();
    const age = currentYearLastTwoDigits - last4DigitsAsNumber;
    const stringValue = value.toString();
    if (!value || !stringValue.length) {
      return true;
    }

    const inputYear = Number(age);
    const max = Number(maxAge);
    if (inputYear > max) {
      return "Age not eligible";
    } else if (inputYear == max && monthAsNumber < currentMonth) {
      return "Age not eligible";
    } else if (
      inputYear == max &&
      monthAsNumber == currentMonth &&
      day < currentDay
    ) {
      return "Age not eligible";
    }
  }
  return true;
});

defineRule("minAge", (value: string, minAge: string) => {
  if (typeof value !== "undefined" && value !== null) {
    const last4DigitsAsNumber = parseInt(value.substring(value.length - 4), 10);
    const monthAsNumber = parseInt(value.substring(3, 5));
    const day = parseInt(value.substring(0, 2));
    const currentYearLastTwoDigits = parseInt(
      new Date().getFullYear().toString(),
      10
    );
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = new Date().getDate();
    const age = currentYearLastTwoDigits - last4DigitsAsNumber;
    const stringValue = value.toString();
    if (!value || !stringValue.length) {
      return true;
    }

    const inputYear = Number(age);
    const min = Number(minAge);
    if (inputYear < min) {
      return "Age not eligible";
    } else if (inputYear == min && monthAsNumber > currentMonth) {
      return "Age not eligible";
    } else if (
      inputYear == min &&
      monthAsNumber == currentMonth &&
      day > currentDay
    ) {
      return "Age not eligible";
    }
  }
  return true;
});

defineRule("minSalary", (value: string, minSalary: string) => {
  if (value === null || value === undefined) {
    return true;
  }
  const stringValue = String(value);
  if (!stringValue.length) {
    return true;
  }

  const inputSalary = Number(value);
  const min = Number(minSalary);
  if (inputSalary < min) {
    return "Amount not eligible";
  }
  return true;
});

defineRule("invalidRecruiterId", (value: any) => {
  return "Invalid Recruiter ID";
});

defineRule("invalidReferenceNo", (value: any) => {
  return "Invalid reference number";
});
